export enum IconColour {
  IconPrimary = 'icon-primary',
  Default = 'default'
}
